var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "ma-0 pa-0",
      staticStyle: {
        display: "grid",
        "justify-content": "center",
        "align-items": "center",
        "min-height": "100%",
        "background-color": "#fff"
      },
      attrs: { fluid: "" }
    },
    [
      _c(
        "div",
        { staticStyle: { "padding-bottom": "50px" } },
        [
          _c(
            "v-card",
            {
              staticClass: "ma-0 pa-0",
              attrs: { flat: "", "max-width": "700px" }
            },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: {
                    prominent: "",
                    outlined: "",
                    text: "",
                    border: "top",
                    color: "info"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "alert-container" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "grid",
                            "justify-content": "center",
                            "align-items": "center",
                            "align-content": "flex-end"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "alert-icon",
                              attrs: { color: "info" }
                            },
                            [_vm._v(" mdi-information-outline ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c("v-col", [
                            _vm._v(
                              " Per message communicated on 3/10/2026 via promoportal@argretailers.com,"
                            ),
                            _c("br"),
                            _vm._v(" your account is disabled from "),
                            _c("strong", [
                              _vm._v("3/23/2026 through 3/29/2026")
                            ]),
                            _vm._v(" while ARG makes updates. "),
                            _c("strong", [
                              _vm._v("Your access will be restored 3/30/2026.")
                            ]),
                            _c("br"),
                            _c("br"),
                            _vm._v(
                              " Any issues or questions can be directed to your category manager."
                            ),
                            _c("br"),
                            _c("br"),
                            _c("strong", [
                              _vm._v(" Thank you,"),
                              _c("br"),
                              _vm._v(" Alliance Retail Group ")
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }